<template>
  <el-dialog
    title="表头排序"
    width="50%"
    :visible="dialogVisible"
    :before-close="closeModal"
    :close-on-click-modal="false"
  >
    <div class="modal-wrap">
      <div class="left-checkbox-wrap">
        <div class="title-operate-wrap">
          <el-checkbox v-model="allCheckFlag" @change="handleSelectAllChange"></el-checkbox>
          <span class="title">动态列选择</span>
        </div>
        <div class="checkbox-wrap">
          <div v-for="item in tableColumn" :key="item.headerName" class="checkbox-item">
            <el-checkbox v-model="item.flag" @change="(value) => handleLeftSelect(value, item)">{{ item.headerName }}</el-checkbox>
          </div>
        </div>
      </div>
      <div class="right-drag-wrap">
        <div class="title-operate">
          <span>已选择{{ selectTableColumn.length }}列</span>
          <span @click="handleDragClear">清除</span>
        </div>
        <vue-draggable
          class="list-group"
          ghostClass="ghost"
          tag="ul"
          v-model="selectTableColumn"
          v-bind="dragOptions"
          @start="drag = true"
          @end="drag = false"
        >
          <transition-group type="transition" :name="!drag ? 'flip-list' : null">
            <div class="select-item" v-for="item in selectTableColumn" :key="item.headerName">
              {{ item.headerName }}
            </div>
          </transition-group>
        </vue-draggable>
      </div>
      <div class="bottom-wrap">
        <el-checkbox v-model="commenColumnFlag">保存为常用自定义列</el-checkbox>
        <el-input
          v-model="columnLabel"
          placeholder="请输入名称"
          style="width: 300px"
          show-word-limit
          v-if="commenColumnFlag"
          maxlength="30"
        ></el-input>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="closeModal">取 消</el-button>
      <el-button type="primary" @click="confirmSelect">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import VueDraggable from "vuedraggable";
import { saveDefineColumn, modifyDefineColumn } from "@/api/tableSort.js";
export default {
  components: {
    VueDraggable,
  },
  data() {
    return {
      dialogVisible: false,
      tableColumn: [],
      // 选择的动态列
      selectTableColumn: [],
      originSelectTableColumn: [],
      drag: false,
      // 是否全选
      allCheckFlag: false,
      // 常用自定义列
      commenColumnFlag: false,
      // 自定义列名
      columnLabel: "",
      // 编辑需要用到的id
      editId: null,
      // 当前编辑列的数组下标
      currentEditIndex: null,
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  methods: {
    showModal(column, selectColumnObj, editIndex) {
      // 设定默认值
      this.allCheckFlag = false;
      this.commenColumnFlag = false;
      this.columnLabel = "";
      this.editId = null;
      this.currentEditIndex = null;

      if (selectColumnObj) {
        // 表示编辑以及回显
        const selectColumn = JSON.parse(selectColumnObj.templateData);
        this.editId = selectColumnObj.id;
        this.commenColumnFlag = true;
        this.columnLabel = selectColumnObj.templateName;
        // 勾选左边
        this.tableColumn = column.map((item) => {
          if (selectColumn.findIndex((i) => i.headerName === item.headerName) !== -1) {
            return {
              ...item,
              flag: true,
            };
          }

          return {
            ...item,
            flag: false,
          };
        });
        // 右边选中列表
        this.selectTableColumn = selectColumn;
        this.originSelectTableColumn = JSON.parse(JSON.stringify(selectColumn));
        if (editIndex >= 0) {
          this.currentEditIndex = editIndex;
        }
        // 编辑
      } else {
        this.originSelectTableColumn = JSON.parse(JSON.stringify(this.selectTableColumn));
        this.tableColumn = column.map((item) => {
          if (this.selectTableColumn.findIndex((i) => i.headerName === item.headerName) !== -1) {
            return {
              ...item,
              flag: true,
            };
          }

          return {
            ...item,
            flag: false,
          };
        });
      }

      this.$nextTick(() => {
        if (this.tableColumn.length === this.selectTableColumn.length) {
          // 全选
          this.allCheckFlag = true;
        }
      });

      this.dialogVisible = true;
    },
    handleLeftSelect (value, item) {
      if (value) {
        // 选中
        this.selectTableColumn.push(item);
      } else {
        this.selectTableColumn = this.selectTableColumn.filter((i) => i.headerName !== item.headerName);
      }
    },
    closeModal() {
      this.allCheckFlag = false;
      this.commenColumnFlag = false;
      this.columnLabel = "";
      this.dialogVisible = false;
      this.selectTableColumn = this.originSelectTableColumn;
    },
    confirmSelect() {
      if (this.selectTableColumn.length === 0) {
        this.$message.warning("请至少选择一个动态列");
      } else {
        if (this.commenColumnFlag && this.columnLabel && !this.editId) {
          // 新增常用自定义列
          saveDefineColumn({
            templateData: JSON.stringify(this.selectTableColumn),
            templateName: this.columnLabel,
          }).then(() => {
            this.$message.success("自定义列保存成功");
            this.$emit("updateSortList", this.selectTableColumn, this.currentEditIndex);
            this.dialogVisible = false;
          });
        } else if (this.commenColumnFlag && this.columnLabel && this.editId) {
          // 编辑自定义列
          modifyDefineColumn({
            templateData: JSON.stringify(this.selectTableColumn),
            templateName: this.columnLabel,
            id: this.editId,
          }).then(() => {
            this.$message.success("自定义列修改成功");
            this.$emit("updateSortList", this.selectTableColumn, this.currentEditIndex);
            this.dialogVisible = false;
          });
        } else {
          this.$emit("updateSortList", this.selectTableColumn, this.currentEditIndex);
          this.dialogVisible = false;
        }
      }
    },
    handleSelectAllChange (value) {
      this.allCheckFlag = value;
      if (value) {
        // 选中状态
        this.tableColumn = this.tableColumn.map((item) => {
          return {
            ...item,
            flag: true,
          };
        });
        this.selectTableColumn = this.tableColumn;
      } else {
        // 未选中状态
        this.tableColumn = this.tableColumn.map((item) => {
          return {
            ...item,
            flag: false,
          };
        });
        this.selectTableColumn = [];
      }
    },
    handleDragClear() {
      this.tableColumn = this.tableColumn.map((item) => {
        if (this.selectTableColumn.findIndex((s) => s.headerName === item.headerName) !== -1) {
          return {
            ...item,
            flag: false,
          };
        }

        return item;
      });
      this.selectTableColumn = [];
    },
  },
};
</script>

<style lang="less" scoped>
.modal-wrap {
  width: 100%;
  max-height: 600px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  .bottom-wrap {
    width: 100%;
    height: 40px;
    display: flex;
    margin-top: 25px;
    align-items: center;
    > * {
      margin-right: 15px;
    }
  }
  .left-checkbox-wrap {
    width: 70%;
    height: 400px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    margin-right: 25px;
    .title-operate-wrap {
      width: 100%;
      background: rgba(244, 244, 244, 0.6);
      padding: 10px;
      .title {
        color: rgba(0, 0, 0, 0.85);
        font-weight: bold;
        font-size: 14px;
        margin: 10px;
      }
    }
    .checkbox-wrap {
      width: 100%;
      padding: 10px;
      display: flex;
      flex-wrap: wrap;
      .checkbox-item {
        width: 220px;
        margin-right: 5px;
      }
    }
  }
  .right-drag-wrap {
    width: 25%;
    height: 400px;
    overflow-y: auto;
    border: 1px solid rgba(0, 0, 0, 0.15);
    .title-operate {
      display: flex;
      justify-content: space-between;
      padding: 8px;
    }
    .title-operate :nth-child(1) {
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
      font-size: 14px;
    }
    .title-operate :nth-child(2) {
      color: #5578e9;
      cursor: pointer;
    }
    .list-group {
      padding: 8px;
      max-height: 400px;
      margin-top: 0px;
      .select-item {
        height: 38px;
        line-height: 38px;
        border-radius: 2px;
        background: rgba(244, 244, 244, 1);
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
        padding-left: 12px;
        position: relative;
        margin-bottom: 8px;
        user-select: none;
      }
    }

    .ghost {
      border: 2px dotted #2a56e3;
      box-sizing: border-box;
    }

    .list-group-item {
      cursor: move;
    }

    .list-group-item i {
      cursor: pointer;
    }
  }
}
</style>
